import { Dispatch } from "react"
import { Action, CheckoutActionKind, State } from "../types/checkoutTypes"

export const incrementCartItem = (
  cartItemId: string,
  state: State,
  dispatch: Dispatch<Action>,
  seatsProductId?: string
) => {
  const { cartItems } = state
  const existingItem = cartItems.find(item => item.productId === cartItemId)

  if (!existingItem) return

  if (seatsProductId) {
    const seatsItem = cartItems.find(item => item.productId === seatsProductId)
    if (seatsItem) {
      //increment the seats
      dispatch({
        type: CheckoutActionKind.INCREMENT_CART_ITEM,
        payload: { cartItemId: seatsProductId },
      })
      return
    }
  }

  // Update global state
  dispatch({
    type: CheckoutActionKind.INCREMENT_CART_ITEM,
    payload: { cartItemId },
  })
}
